import {
    GET_TOKENIZATION_REQUESTS_REQUEST,
    GET_TOKENIZATION_REQUESTS_SUCCESS,
    GET_TOKENIZATION_REQUESTS_FAILURE,
} from '../../constants';

const initialTokenizationRequestsState = {
    loader: false,
    success: false,
    failed: false,
    defaultPaymentMethod: null,
    takePaymentOnAuth: null,
    businessUnit: null,
    amount: null,
};
  
export default (state = initialTokenizationRequestsState, action) => {
    //This is to ensure immutability of state
    const newState = {...state};
  
    switch (action.type) {
    case GET_TOKENIZATION_REQUESTS_REQUEST:
        newState.loader = true;
        newState.failed = false;
        newState.success = false;
        return newState;
    case GET_TOKENIZATION_REQUESTS_SUCCESS:
        newState.amount = action.data.amount;
        newState.defaultPaymentMethod = action.data.default_payment_method;   
        newState.takePaymentOnAuth = action.data.take_payment_on_auth;
        newState.businessUnit = action.data.business_unit || null;
        newState.loader = false;    
        newState.success = true;
        newState.failed = false;
        return newState;
    case GET_TOKENIZATION_REQUESTS_FAILURE:
        newState.loader = false;
        newState.failed = true;
        newState.success = false;
        return newState;
    default:
        return state;
    }
};
